<template>
  <div class="gallery_card">
    <div class="table table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">
            Name
            <i class="fa fa-arrow-down" v-on:click="setSortOrder('t-d')"></i>
            <i class="fa fa-arrow-up" v-on:click="setSortOrder('t-a')"></i>
          </th>
          <th scope="col">
            Author
            <i class="fa fa-arrow-down" v-on:click="setSortOrder('a-d')"></i>
            <i class="fa fa-arrow-up" v-on:click="setSortOrder('a-d')"></i>
          </th>
          <th scope="col">
            Last Updated Date
            <i class="fa fa-arrow-down" v-on:click="setSortOrder('d-d')"></i>
            <i class="fa fa-arrow-up" v-on:click="setSortOrder('d-a')"></i>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in newList"
          :key="index"
          @click="viewStoryDetail(item)"
        >
          <td>{{ item.title }}</td>
          <td>{{ item.author }}</td>
          <td>{{ item.date }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <hr/>
    <!-- <nav>
      <ul class="pagination justify-content-center">
        <li class="page-item disabled">
          <a class="page-link" href="#" tabindex="-1">Previous</a>
        </li>
        <li class="page-item"><a class="page-link" href="#">1</a></li>
        <li class="page-item active">
          <a class="page-link" href="#">2 <span class="sr-only">(current)</span></a>
        </li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item">
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav> Disabled pagination -->
  </div>
</template>

<script>
export default {
  name: 'listCard1',
  data: () => ({}),
  props: ['newList'],
  watch: {},
  mounted () {
  },
  methods: {
    setSortOrder: function (value) {
      this.$emit('setSortOrderListView', value)
    },
    viewStoryDetail (story) {
      this.$emit('viewStoryDetail', story)
    },
  },
}
</script>

<style scoped lang="scss">
.card-shadow {
  border: solid 1px #d1d1d1;
  box-shadow: -1px 1px 20px -7px #000;
  overflow: hidden;
}

.table {
  min-width: 1225px;
}

table {
  min-width: 1225px !important;
  th {
    i {
      opacity: 0.5;
      margin-left: 10px;
    }
  }
}

.page-link {
  color: #212121;
}

.page-item.active .page-link {
  background-color: #212121;
  border-color: #212121;
}
  .gallery_card{
    min-width: 23rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/story-list-view/listCard1.vue